/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { Sale } from '../../core/_models'
import { formatDateTime } from '../../../../../utils/dayJs/format'

type Props = {

    sale: Sale
}

const CreatedInCell: FC<Props> = ({ sale }) => (

    <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-danger mb-1'>
            {sale.createdAt ? formatDateTime(sale.createdAt.toString()) : 'N/A'}
        </a>
        {/* <span>{franchise.createdAt ? franchise.createdAt.toString() : 'N/A'}</span> */}
    </div>
)

export { CreatedInCell }
